import request from "@/utils/request"

export function login(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/Login",
    method: "get",
    params
  })
}

export function getInfo(token) {
  return request({
    url: "/vue-admin-template/user/info",
    method: "get",
    params: { token }
  })
}

export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post"
  })
}

export function getRoutes() {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetModules",
    method: "get"
  })
}

// curd 角色
export function addRole(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/AddRole",
    method: "post",
    data
  })
}
export function deleteRole(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/DelRole",
    method: "get",
    params
  })
}
export function updateRole(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/UpdRole",
    method: "post",
    data
  })
}
export function getRole(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetRoleTab",
    method: "get",
    params
  })
}
export function getRoleSelectList(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetRoleSelectLs",
    method: "get",
    params
  })
}
export function getMerchantSelectList(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetMerchantSelectLs",
    method: "get",
    params
  })
}

// crud 用户
export function getUserList(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetUserTable",
    method: "get",
    params
  })
}

export function addUser(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/AddUser",
    method: "post",
    data
  })
}
export function updateUser(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/UpdUser",
    method: "post",
    data
  })
}
export function deleteUser(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/DelUser",
    method: "get",
    params
  })
}
export function getUserInfoList(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetUserInfo",
    method: "get",
    params
  })
}
export function enableUser(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/Disable",
    method: "get",
    params
  })
}

// crud 菜单
export function getMenusTree(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetModulesTableTree",
    method: "get",
    params
  })
}
export function addMenu(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/AddModule",
    method: "post",
    data
  })
}
export function getMenuDetail(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetModulesTable",
    method: "get",
    params
  })
}
export function updateMenu(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/UpdModule",
    method: "post",
    data
  })
}
export function deleteMenu(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/DelModule",
    method: "get",
    params
  })
}

export function getMenuByRoleId(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetSelectRoleMoudule",
    method: "get",
    params
  })
}
export function assginMenus(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/Assign",
    method: "get",
    params
  })
}

export function getSystemLog(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/Syslog",
    method: "get",
    params
  })
}

export function getUserListByRole(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetUserTableByRole",
    method: "get",
    params
  })
}

export function getVerifyCode(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/Captcha",
    method: "get",
    params
  })
}

// crud 商户
export function addGroup(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/AddGroup",
    method: "post",
    data
  })
}
export function updateGroup(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/UptGroup",
    method: "post",
    data
  })
}
export function deleteGroup(data) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/DelGroup",
    method: "post",
    data
  })
}
export function getGroups(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetGroupList",
    method: "get",
    params
  })
}
export function getGroupSelectList(params) {
  return request({
    url: "/Anno.Plugs.Rules/Authority/GetGroupSelectList",
    method: "get",
    params
  })
}
